function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

class PredictiveSearch extends HTMLElement {
    constructor() {
        super();
        this.header = document.querySelector('header');
        this.cachedResults = {};
        this.input = this.querySelector('input[type="text"]');
        this.predictiveSearchResults = document.querySelector('.search-results');
        this.setupEventListeners();
    }

    setupEventListeners() {
        this.input.addEventListener('input', debounce((event) => {
            this.onChange(event);
        }, 300).bind(this));
    }

    get getQuery() {
        return this.input.value.trim();
    }

    onChange() {
        const searchTerm = this.getQuery;
        this.getSearchResults(searchTerm);
    }

    getSearchResults(searchTerm) {
        const queryKey = searchTerm.replace(" ", "-").toLowerCase();

        this.header.classList[searchTerm.length > 0 ? 'add' : 'remove']('search-active');

        if (this.cachedResults[queryKey]) {
            this.renderSearchResults(this.cachedResults[queryKey]);
            return;
        }

        fetch(`${window.routes.search_url}?q=${encodeURIComponent(searchTerm)}*&type=product&section_id=predictive-search`)
            .then((response) => {
                if (!response.ok) {
                    let error = new Error(response.status);
                    throw error;
                }
                return response.text();
            })
            .then((text) => {
              const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('.search-results').innerHTML;
              if(resultsMarkup.length > 0){
                  this.cachedResults[queryKey] = resultsMarkup;
                  this.renderSearchResults(resultsMarkup);
              }
            })
            .catch((error) => {
                throw error;
            });
    }

    renderSearchResults(resultsMarkup) {
        if (this.input.value.length > 0) {
            this.predictiveSearchResults.innerHTML = resultsMarkup;
        }
    }
}

customElements.define('predictive-search', PredictiveSearch);